<template>
  <div>
    <CheckBox class="ml-4 mt-6 mb-0" 
      :label="$t('Использовать геокодирование')" 
      :hint="$t('В процессе обработки заказов будет использоваться функционал геокодирования')" 
      :original_value="config.enabled" 
      v-model="local_config.enabled"/>
    <!-- Камент ниже на будущее, когда появится несколько геопровайдеров -->
    <!-- <div class="d-flex align-center mb-3">
      <h4><T>Выберите провайдера геоданных</T></h4>
    </div>
    <v-tabs  vertical v-model="geocoder_tab">
      <v-tab test-tag="tag-182" :disabled="!local_config.enabled">DaData</v-tab>
      <v-tab test-tag="tag-183" disabled>Yandex</v-tab>
      <v-tab test-tag="tag-184" disabled>OSM</v-tab>
      <v-tab-item>
        <DaData :loading="any_loading" :disabled="!local_config.enabled" :original_value="config.dadata" v-model="local_config.dadata" />
      </v-tab-item>
    </v-tabs> -->

    <DaData :loading="any_loading" :disabled="!local_config.enabled" :original_value="config.dadata" v-model="local_config.dadata" />
    
  </div>
</template>

<script>

import DaData from './DaData.vue'
import CheckBox from '../../common/CheckBox.vue'


import  settings_group_mixin from '../settings_group_mixin'
export default {
  mixins: [settings_group_mixin],
  methods: {
    validate(){
      if (this.local_config.enabled == true) {
        if (this.local_config.provider === 'dadata') {
          if (!this.local_config.dadata.token) {
            throw new Error(this.$t('Укажите API-ключ DaData'))
          }
        }
      }
    }
  },
  watch: {
    'local_config.enabled'(v) {
      this.$emit ('desabled', v) 
    }
  },
  computed: {
    geocoders(){
      return ['dadata']
    },
    geocoder_tab: {
      get(){
        try {
          return this.geocoders.indexOf(this.local_config.geocoding.provider)
        } catch {
          return 0
        }
      },
      set(v){
        this.local_config.geocoding.provider = this.geocoders[v]
      }
    }
  },
  components:{
    DaData,
    CheckBox
  }
}
</script>